var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"circle-bar circle-bar__progress-bar",class:_vm.circleBarType,style:('background-image: ' + _vm.backgroundImage)},[_c('div',{staticClass:"circle-bar__overlay",style:(_vm.circleBarStyle)},[(!_vm.text)?_c('span',[_vm._v(_vm._s(_vm.value + '%'))]):_c('span',[_vm._v(_vm._s(_vm.text))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }